Namespace 'Customer.Tabs'

class Customer.Tabs.TabScrollingView extends Backbone.View
  template: JST['backbone/templates/customer/tabs/tab_scrolling']
  id: 'tab-scroll-container'
  scrollDistance: '600px'
  scrollDuration: 400

  initialize: ->
    $(window).resize(@updateDisabledScrollButtons)
    new ResizeSensor $('#menu-wrapper'), @updateDisabledScrollButtons

  render: ->
    @$el.html(@template())
    @updateDisabledScrollButtons()
    @$el.find('#tab-scroll-left').on('click', => @scroll("-=#{@scrollDistance}"))
    @$el.find('#tab-scroll-right').on('click', => @scroll("+=#{@scrollDistance}"))
    @

  setScrollableElement: ($element) =>
    @$scrollingElement = $element

  scroll: (offset) =>
    @$scrollingElement?.scrollTo(
      left: offset,
      top: '0px',
      @scrollDuration,
      onAfter: @updateDisabledScrollButtons
    )

  scrollTo: ($element) =>
    @$scrollingElement?.scrollTo(
      $element,
      @scrollDuration,
      onAfter: @updateDisabledScrollButtons
    )

  updateDisabledScrollButtons: =>
    return unless @$scrollingElement
    {scrollLeft, clientWidth, scrollWidth} = @$scrollingElement[0]
    @updateDisabled
      left: scrollLeft == 0
      right: scrollLeft + clientWidth == scrollWidth

  updateDisabled: ({left, right}) =>
    @$el.find('#tab-scroll-left').toggleClass('disabled', left)
    @$el.find('#tab-scroll-right').toggleClass('disabled', right)
